// The basemap credits Cesium is showing for the current view, read from its
// credit display so a printout attributes exactly what was on screen: the
// on-screen logos (Cesium ion, Google) and the per-view copyright lines that
// sit behind the "Data attribution" link (Google's "Imagery ©2026 Airbus,
// Maxar Technologies", Bing's provider list, and so on).
//
// Cesium rebuilds both lists every frame from the tiles actually rendered,
// which is what the Google and ion terms ask a static output to carry.
export const EMPTY_VIEWER_CREDITS = { logosHtml: [], copyright: [] };
// Trim, drop blanks and exact repeats, keep first-seen order. Cesium lists a
// copyright once per rendered tile level, so neighbouring levels often repeat.
export const mergeCreditLines = (lines) => {
    const seen = new Set();
    const out = [];
    for (const raw of lines) {
        const line = (raw !== null && raw !== void 0 ? raw : '').replace(/\s+/g, ' ').trim();
        if (!line || seen.has(line))
            continue;
        seen.add(line);
        out.push(line);
    }
    return out;
};
export const viewerCreditsEqual = (a, b) => a.logosHtml.length === b.logosHtml.length &&
    a.copyright.length === b.copyright.length &&
    a.logosHtml.every((v, i) => v === b.logosHtml[i]) &&
    a.copyright.every((v, i) => v === b.copyright[i]);
// Cesium hardcodes the credit link and lightbox wording with no option to
// change them, and never rewrites them after construction, so they are set
// once on the built viewer. Google's policy only suggests a label; everything
// behind the link is imagery copyright, so say so.
export const CREDIT_LINK_LABEL = 'Imagery attribution';
export const CREDIT_LIGHTBOX_TITLE = 'Imagery provided by:';
export const labelViewerCredits = (root) => {
    const link = root.querySelector('.cesium-credit-expand-link');
    if (link)
        link.textContent = CREDIT_LINK_LABEL;
    const title = root.querySelector('.cesium-credit-lightbox-title');
    if (title)
        title.textContent = CREDIT_LIGHTBOX_TITLE;
    const lightbox = root.querySelector('.cesium-credit-lightbox');
    if (lightbox)
        lightbox.setAttribute('aria-label', CREDIT_LINK_LABEL);
};
// ion's "Upgrade for commercial use." link on Community-plan tokens. Hidden on
// screen by styles.css; dropped here so the printout never carries it either.
const ION_UPSELL_HREF = 'cesium.com/pricing';
export const isIonUpsellCredit = (html) => html.includes(ION_UPSELL_HREF);
const ON_SCREEN_SELECTOR = '.cesium-credit-logoContainer .cesium-credit-wrapper, .cesium-credit-textContainer .cesium-credit-wrapper';
const LIGHTBOX_SELECTOR = '.cesium-credit-lightbox > ul > li';
// `root` is the viewer's container element; Cesium mounts both the credit bar
// and the attribution lightbox inside it.
export const readViewerCredits = (root) => {
    const logosHtml = mergeCreditLines(Array.from(root.querySelectorAll(ON_SCREEN_SELECTOR))
        .map((el) => el.innerHTML)
        .filter((html) => !isIonUpsellCredit(html)));
    const copyright = mergeCreditLines(Array.from(root.querySelectorAll(LIGHTBOX_SELECTOR)).map((el) => el.textContent));
    return { logosHtml, copyright };
};
